import { render, staticRenderFns } from "./CriticalEngagements.vue?vue&type=template&id=1b583beb&"
import script from "./CriticalEngagements.vue?vue&type=script&lang=js&"
export * from "./CriticalEngagements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports